import React from 'react';
import PropTypes from 'prop-types';
import { OutlineButton } from '../../@communityshare/ui/Button';
import { SolidButton } from '../../@communityshare/ui/Button';
import StringField from '../../forms/_fields_v2/StringField';
import TextAreaField from '../../forms/_fields_v2/TextAreaField';
import FormTemplate from '../../dialogs_common/FormTemplate';
import FormField from '../../forms/_common/FormField';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';
import DESCRIPTION_MAX_LENGTH from '../network_support_question_create/DESCRIPTION_MAX_LENGTH';

Form.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  alert: PropTypes.node,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
};

Form.defaultProps = {
  // data: {},
  errors: {},
  showErrors: false,
  onChange: () => {}
};

export default function Form(props) {
  const {
    data,
    errors,
    showErrors,
    alert,
    onChange,
    onSubmit,
    onClose
  } = props;

  function sectionTitle(title, description) {
    return (
      <div>
        <div className="text-lg font-semibold text-cs-gray-700">
          {title}
        </div>
        <div>
          {description}
        </div>
      </div>
    );
  }

  return (
    <FormTemplate
      title="Edit steward contact"
      subtitle="Fill out the information below to make changes to the support contact."
      onClose={onClose}
      alert={alert}
      body={(
        <div className="space-y-8">
          <FormField name="stewardName" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Name*"
                placeholder="Name..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="stewardDescription" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <TextAreaField
                label="Description*"
                placeholder="Description..."
                rows={4}
                description={`${data.stewardDescription ? data.stewardDescription.length : 0}/${DESCRIPTION_MAX_LENGTH} characters`}
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="stewardAvatarUrl" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Avatar URL"
                placeholder="URL..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="stewardEmail" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Email"
                placeholder="Email..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="stewardPhone" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Phone"
                placeholder="Email..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="stewardCustomUrl" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Custom URL"
                placeholder="https://..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
          <FormField name="stewardCustomLabel" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <StringField
                label="Custom Label for URL"
                placeholder="Label..."
                // description="Some text about a thing I like"
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
            )}
          </FormField>
        </div>
      )}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onClose}>
            Cancel
          </OutlineButton>
          <SolidButton onClick={onSubmit}>
            Update support contact
          </SolidButton>
        </FormTemplateButtonFooter>
      )}
    />
  );
}
